import request from "@/utils/request";

export function queryShopTrackList(params) {
  return request({
    url: "api/system/shopTrack/queryTrackAndProduct",
    method: "post",
    data: params
  });
}
//添加我的足迹
export function saveShopTrack(params) {
  return request({
    url: "/api/system/shopTrack/saveShopTrack",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/track/index.js